// Copyright (c) 2020-2023 Omics Data Automation, Inc.
// Copyright (c) 2023 datma, inc.
//
// Proprietary and Confidential:
// Unauthorized copying of this file by any medium is strictly prohibited.

export const mergeByMrn = (a1, a2) =>
  a1.map((itm) => ({
    ...a2.find((item) => item.MRN.includes(itm.mrn) && item),
    ...itm,
  }))

export const mergeByPhysicianId = (a1, a2) =>
  a1.map((itm) => ({
    ...a2.find((item) => item.care_giver_id === itm.care_giver_id && item),
    ...itm,
  }))
